import { type RefObject, useCallback, useLayoutEffect, useRef } from 'react';

export const useCollapsedSectionFocus = (expanded: boolean, headerRef: RefObject<HTMLDivElement>) => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  const restoreHeaderFocus = useCallback(() => {
    const content = contentRef.current;

    if (content?.contains(content.ownerDocument.activeElement)) {
      headerRef.current?.focus();
    }
  }, [headerRef]);

  const setContentRef = useCallback(
    (node: HTMLDivElement | null) => {
      // Capture ownership before React removes an immediately hidden section;
      // after deletion activeElement is already body and the ref is cleared.
      if (!node) {
        restoreHeaderFocus();
      }
      contentRef.current = node;
    },
    [restoreHeaderFocus]
  );

  useLayoutEffect(() => {
    // Animated sections remain mounted during exit, so restore focus as soon
    // as they close rather than waiting for the ref to detach.
    if (!expanded) {
      restoreHeaderFocus();
    }
  }, [expanded, restoreHeaderFocus]);

  return setContentRef;
};
